module.exports = __webpack_public_path__ + "img/jjj.099e8938.png";